import React from 'react'

export const ClockIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99984 1.66675C5.4165 1.66675 1.6665 5.41675 1.6665 10.0001C1.6665 14.5834 5.4165 18.3334 9.99984 18.3334C14.5832 18.3334 18.3332 14.5834 18.3332 10.0001C18.3332 5.41675 14.5832 1.66675 9.99984 1.66675ZM10.8332 10.0001C10.8332 10.3334 10.6665 10.5834 10.4165 10.7501L8.24984 12.0001C7.83317 12.2501 7.33317 12.0834 7.08317 11.6667C6.83317 11.2501 6.99984 10.7501 7.4165 10.5001L9.1665 9.50008V5.83341C9.1665 5.33341 9.49984 5.00008 9.99984 5.00008C10.4998 5.00008 10.8332 5.33341 10.8332 5.83341V10.0001Z" fill="#00A0FF"/>
    </svg>
  )
}
